import widgetIndexData from "components/config/dashboard-templates/widget-index.generated.json";
const typedIndex = widgetIndexData;
export const getWidgetIndex = () => typedIndex;
export const getWidgetIndexEntry = (widgetId) => typedIndex[widgetId];
export const getWidgetIndexIds = () => Object.keys(typedIndex);
let cachedDefaultWidgets = null;
export const getWidgetIndexAsDefaultWidgets = () => {
    if (cachedDefaultWidgets) {
        return cachedDefaultWidgets;
    }
    const result = {};
    Object.entries(typedIndex).forEach(([key, entry]) => {
        result[key] = {
            componentName: entry.componentName,
            componentProps: entry.componentProps ?? {},
            id: entry.id,
            metaData: entry.metaData,
            name: entry.name
        };
    });
    cachedDefaultWidgets = result;
    return result;
};
